import { render } from "./StartGameDemo.vue?vue&type=template&id=1e99c8c6"
import script from "./StartGameDemo.vue?vue&type=script&lang=js"
export * from "./StartGameDemo.vue?vue&type=script&lang=js"

import "./StartGameDemo.vue?vue&type=style&index=0&id=1e99c8c6&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__